import { Action } from '@ngrx/store';
import { UserActivity } from '../../domain/models';
import * as viewModels from '../../view/view-models';

export const LOAD_USER_ACTIVITIES = '[RM User Activities Collection] Load User Activities';
export const LOAD_USER_ACTIVITIES_FAILURE = '[RM User Activities Collection] Load User Activities Failure';
export const LOAD_USER_ACTIVITIES_SUCCESS = '[RM User Activities Collection] Load User Activities Success';
export const RESET = '[RM User Activities Collection] Reset';

export class LoadPayload {
  constructor(public lookup: viewModels.UsersActivitiesLookup) { }
}

export class LoadUserActivitiesAction implements Action {
  readonly type = LOAD_USER_ACTIVITIES;

  constructor(public payload: LoadPayload) { }
}

export class LoadUserActivitiesFailureAction implements Action {
  readonly type = LOAD_USER_ACTIVITIES_FAILURE;
}

export class LoadUserActivitiesSuccessPayload {
  activities: Array<UserActivity>;
  totalItems: number;
}

export class LoadUserActivitiesSuccessAction implements Action {
  readonly type = LOAD_USER_ACTIVITIES_SUCCESS;

  constructor(public payload: LoadUserActivitiesSuccessPayload) { }
}

export class ResetAction implements Action {
  readonly type = RESET;
}

export type Actions =
  | LoadUserActivitiesAction
  | LoadUserActivitiesFailureAction
  | LoadUserActivitiesSuccessAction
  | ResetAction;
